import { render, staticRenderFns } from "./RealEstate.vue?vue&type=template&id=4aa05e40&scoped=true&"
import script from "./RealEstate.vue?vue&type=script&lang=js&"
export * from "./RealEstate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa05e40",
  null
  
)

export default component.exports